const binaryToFlags = (flags, binaryNum) => flags.filter(f => f & binaryNum);

export default binaryToFlags;